export default "__VITE_ASSET__42b700a8__"